import { captureError } from './error';

export function logError(
  error: unknown,
  context?: string,
  details?: Record<string, unknown>,
): void {
  if (process.env.NODE_ENV !== 'test') {
    console.error(context ? `${context}:` : 'Error:', error, details);
    captureError(error, context, details);
  }
}
